import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Login } from '../models/LoginView';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly urlPath = 'authentication';

  constructor(private httpClient: HttpClient) {}

  login(request: any, prefix: string): Observable<Login> {
    return this.httpClient
      .post<Login>(
        `${environment.apiUrl}${this.urlPath}/login`,
        this.setupRequest(request),
      )
      .pipe();
  }

  forgotPassword(email: string): Observable<any> {
    const request = {
      email,
      baseUrl: environment.baseUrl,
    };
    return this.httpClient.post<any>(
      `${environment.apiUrl}${this.urlPath}/reset-password`,
      this.setupRequest(request),
    );
  }

  validateResetToken(
    email: string,
    token: string,
    clientId: string,
  ): Observable<any> {
    const request = { email, token, clientId };
    return this.httpClient
      .post<any>(
        `${environment.apiUrl}${this.urlPath}/validate-reset-token`,
        request,
      )
      .pipe();
  }

  resetPassword(request: any): Observable<any> {
    return this.httpClient
      .post<any>(
        `${environment.apiUrl}${this.urlPath}/complete-reset-password`,
        request,
      )
      .pipe();
  }

  private setupRequest(request: any) {
    const formData: FormData = new FormData();
    formData.append('model', JSON.stringify(request));
    return formData;
  }
}
